module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-rounded push"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: " form-group row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center push"
  }, [_c('button', {
    staticClass: "btn  btn-success align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.startMeasurement
    }
  }, [_c('i', {
    staticClass: "fa fa-bars fa-1x push-5-r "
  }), _vm._v(" " + _vm._s(_vm.buttonLabelStartAcquisition[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flagDisplayLiveData),
      expression: "flagDisplayLiveData"
    }],
    staticClass: "col-xs-12 col-sm-12 push"
  }, [(_vm.flagDisplayMessageHowToUse) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('h2', {
    staticClass: "block-title align-center"
  }, [_vm._v(_vm._s(_vm.messageHowToUse[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.channelList), function(channel, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6"
    }, [_c('div', {
      staticClass: "block block-bordered"
    }, [_c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 align-center"
    }, [_c('span', {
      staticClass: "h3 text-black-op",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(channel.channelName))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 align-center"
    }, [_c('a', {
      staticClass: "block block-link-hover block-rounded"
    }, [_c('div', {
      staticClass: "block-content block-content-full clearfix",
      style: ({
        backgroundColor: channel.color
      })
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('span', {
      staticClass: "h3 text-white-op",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.tileTotalPower[_vm.actualLanguage]) + " : " + _vm._s(channel.lastTotalPower) + " W")])]), _vm._v(" "), _vm._l((channel.devicePorts), function(port, index2) {
      return _c('div', {
        staticClass: "col-xs-12"
      }, [_c('span', {
        staticClass: "h4 text-white-op",
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(_vm.tileSensor[_vm.actualLanguage]) + " " + _vm._s(index2 + 1) + ": " + _vm._s(channel.lastPower[index2]) + " W / " + _vm._s(channel.lastCurrent[index2]) + " A")])])
    })], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-9"
    }, [_c('h4', {
      staticClass: "h5 text-center"
    }, [_vm._v(_vm._s(_vm.labelDisplayGraph[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (channel.flagDisplayGraph),
        expression: "channel.flagDisplayGraph"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(channel.flagDisplayGraph) ? _vm._i(channel.flagDisplayGraph, null) > -1 : (channel.flagDisplayGraph)
      },
      on: {
        "change": function($event) {
          var $$a = channel.flagDisplayGraph,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(channel, "flagDisplayGraph", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(channel, "flagDisplayGraph", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(channel, "flagDisplayGraph", $$c)
          }
        }
      }
    }), _c('span')])])]), _vm._v(" "), (channel.flagDisplayGraph) ? _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-9"
    }, [_c('h5', {
      staticClass: "h5 text-center"
    }, [_vm._v(_vm._s(_vm.labelDisplayCurrent[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (channel.flagDisplayCurrent),
        expression: "channel.flagDisplayCurrent"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(channel.flagDisplayCurrent) ? _vm._i(channel.flagDisplayCurrent, null) > -1 : (channel.flagDisplayCurrent)
      },
      on: {
        "change": [function($event) {
          var $$a = channel.flagDisplayCurrent,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(channel, "flagDisplayCurrent", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(channel, "flagDisplayCurrent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(channel, "flagDisplayCurrent", $$c)
          }
        }, function($event) {
          return _vm.updateGraphData(index)
        }]
      }
    }), _c('span')])])]) : _vm._e(), _vm._v(" "), (channel.flagDisplayGraph) ? _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      attrs: {
        "id": "chart"
      }
    }, [_c('apexchart', {
      attrs: {
        "type": "area",
        "height": "300",
        "options": _vm.chartOptions,
        "series": _vm.chartDataSeries[index]
      }
    })], 1)]) : _vm._e()])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center push"
  }, [_c('button', {
    staticClass: "btn  btn-success align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.stopMeasurement
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(" " + _vm._s(_vm.buttonClose[_vm.actualLanguage]))])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21b642f7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/SubComponents/PowerLiveMonitor.vue
// module id = 1497
// module chunks = 4